import { ContextType, ChatMessage, ChatRole } from '../models/agent.models';

// Helper function to get context messages based on type
export function getContextMessages(messages: ChatMessage[], contextType: ContextType): ChatMessage[] {
  const conversationMessages = messages.filter((message) => [ChatRole.User, ChatRole.Assistant].includes(message.role));

  if (conversationMessages.length === 0) {
    return [];
  }

  switch (contextType) {
    case ContextType.LastAssistantMessage: {
      const lastAssistant = conversationMessages
        .slice()
        .reverse()
        .find((m) => m.role === ChatRole.Assistant);
      return lastAssistant ? [lastAssistant] : [];
    }
    case ContextType.LastUserMessage: {
      const lastUser = conversationMessages
        .slice()
        .reverse()
        .find((m) => m.role === ChatRole.User);
      return lastUser ? [lastUser] : [];
    }
    case ContextType.LastDialog: {
      const lastUser = conversationMessages
        .slice()
        .reverse()
        .find((m) => m.role === ChatRole.User);
      const lastAssistant = conversationMessages
        .slice()
        .reverse()
        .find((m) => m.role === ChatRole.Assistant);
      const dialog: ChatMessage[] = [];
      if (lastAssistant) dialog.push(lastAssistant);
      if (lastUser) dialog.push(lastUser);
      // Sort by timestamp if available, otherwise keep order [Assistant, User] if both exist
      // Assuming messageId or a timestamp property exists and is comparable
      // dialog.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0)); // Example sorting
      return dialog;
    }
    case ContextType.Last2Dialogs: {
      // I think i have an error with this.
      const users = conversationMessages.filter((m) => m.role === ChatRole.User);
      const assistants = conversationMessages.filter((m) => m.role === ChatRole.Assistant);
      const lastTwoUsers = users.slice(-2);
      const lastTwoAssistants = assistants.slice(-2);
      const dialogs = [...lastTwoAssistants, ...lastTwoUsers];
      // Sort by timestamp if available
      // dialogs.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0)); // Example sorting
      return dialogs;
    }
    case ContextType.LastUserAndPreviousAssistant: {
      const lastUserIndex = conversationMessages.map((m) => m.role).lastIndexOf(ChatRole.User);
      // Not exactrly getting the last assistant will depend if conversation is one and one.

      if (lastUserIndex <= 0) {
        return [];
      }

      const messages = conversationMessages.slice(lastUserIndex - 1, lastUserIndex + 1);
      console.log('LastUserAndPreviousAssistant', messages);
      return messages;
    }
    case ContextType.AllConversation:
    default:
      return conversationMessages;
  }
}
